import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RoleDetailsService } from '../../../core/services/role-details.service';
import { TableService } from '../../../core/services/table.service';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
  standalone: false,
})
export class SideNavigationComponent implements OnInit {
  @Input() menu;
  selectedItem1;
  constructor(
    private route: Router,
    private roleService: RoleDetailsService,
    private _tableService: TableService,
  ) {}
  ngOnInit() {
    this.selectedItem1 = this.menu[0].menu;
  }

  navigate(data) {
    console.log('side nav data--- DCAS VLAS' + JSON.stringify(data));
    // if(data.subRole === "DCAS"){
    //   this._tableService.setCandidateID({});
    // }
    // else if(data.subRole === "VLAS"){
    //   this._tableService.setCandidateID({});
    // }
    if (data.subRole === 'DCAS' || data.subRole === 'VLAS') {
      this._tableService.setCandidateID({});
    }

    this.roleService.updateRole(data.subRole);
    this.route.navigate([data.path]);
  }

  handleClick(item) {
    // if (item == 1) {
    //   this.selectedItem1 = this.menu[1].menu;
    // }
    // else if (item == 2) {
    //   this.selectedItem1 = this.menu[2].menu;
    // }
    // else {
    //   this.selectedItem1 = this.menu[0].menu;
    // }
    // if (item == 1) {
    //   this.selectedItem1 = this.menu[1].menu;
    // } else {
    //   this.selectedItem1 = this.menu[0].menu;
    // }

    this.selectedItem1 = this.menu[item].menu;
  }
}
